import { type PdpRespAboutModule_item$data } from '../PdpRespAboutModule/__generated__/PdpRespAboutModule_item.graphql.ts';
import {
    ITEM_IS_RING_RESIZABLE_ATTRIBUTE_ID,
    ITEM_IS_CUSTOMIZABLE_ATTRIBUTE_ID,
} from '../../constants/itemConstants.ts';

export const getAttributeInfo = (
    attributes: PdpRespAboutModule_item$data['attributes']
): {
    customizationOptions: string | null | undefined;
    isResizable: boolean;
} => {
    const customizableAttrs = attributes?.customizable || [];
    const regularCustomizable = customizableAttrs.find(
        customizableOption =>
            customizableOption?.option?.serviceId === ITEM_IS_CUSTOMIZABLE_ATTRIBUTE_ID
    );

    return {
        customizationOptions: regularCustomizable?.text,
        isResizable:
            attributes?.ringResizable?.[0]?.option?.serviceId ===
            ITEM_IS_RING_RESIZABLE_ATTRIBUTE_ID,
    };
};
